module.exports = __webpack_public_path__ + "img/GB_ACT.6a82ed6a.png";